import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "tab-pane fade border border-top-0",
  id: "panel-pub-thesis",
  role: "tabpanel",
  "aria-labelledby": "tab-pub-thesis"
}
const _hoisted_2 = { class: "container p-3" }
const _hoisted_3 = { class: "list-group" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = ["href", "target", "innerHTML"]
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theses, (thesis, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "list-group-item"
          }, [
            _createElementVNode("h5", _hoisted_4, [
              _createTextVNode("[" + _toDisplayString(thesis.type) + "] ", 1),
              _createElementVNode("a", {
                href: thesis.hasOwnProperty('url') ? thesis.url : '',
                target: thesis.hasOwnProperty('url') ? '_blank' : '_self',
                innerHTML: thesis.title
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("p", _hoisted_6, _toDisplayString(thesis.text), 1),
            (thesis.hasOwnProperty('note'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "mb-0",
                  innerHTML: thesis.note
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}